import { CfColSize, ColSize, ColSizeValue } from "types/generic/types";

interface CfColSizeDictionary {
  [key: number]: ColSizeValue;
}

const CF_COL_SIZE_DICTIONARY: CfColSizeDictionary = {
  1: "12",
  2: "6",
  3: "4",
  4: "3",
  5: "2",
  6: "2",
  7: "1",
  8: "1",
  9: "1",
  10: "1",
  11: "1",
  12: "1",
};

export const convertCfColSizeProps = (cfProp: CfColSize): ColSize => {
  if (!cfProp)
    return {
      xsColSize: CF_COL_SIZE_DICTIONARY[1],
    };

  return {
    xsColSize: cfProp.default
      ? CF_COL_SIZE_DICTIONARY[cfProp.default]
      : CF_COL_SIZE_DICTIONARY[1],
    smColSize: cfProp.sm ? CF_COL_SIZE_DICTIONARY[cfProp.sm] : undefined,
    mdColSize: cfProp.md ? CF_COL_SIZE_DICTIONARY[cfProp.md] : undefined,
    lgColSize: cfProp.lg ? CF_COL_SIZE_DICTIONARY[cfProp.lg] : undefined,
    xlColSize: cfProp.xl ? CF_COL_SIZE_DICTIONARY[cfProp.xl] : undefined,
  };
};
